import React from 'react';
import submittedImage from "../../assets/submitted.webp";

export default function THEProblem({
  label = "THE PROBLEM",
  title = "You find the borrower. Then the file disappears into WhatsApp threads, unreturned calls, and a commission nobody can explain.",
  description = "Finverse logs the lead the moment you submit it, verifies it before a lender sees it, and shows you the money trail from disbursal to bank transfer.",
  image = submittedImage,
  imageAlt = "DSA agent with phone",
}) {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">
        <div className="grid grid-cols-1 items-center gap-10 md:gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 xl:gap-24">
          
          {/* Left: 3D Character Illustration */}
          <div className="flex items-center justify-center lg:justify-center">
            <img
              src={image}
              alt={imageAlt}
              className="h-auto w-[220px] object-contain sm:w-[260px] md:w-[290px] lg:w-[320px]"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Right: Content */}
          <div>
            {/* Label */}
            <p className="font-jakarta text-[11px] sm:text-[12px] font-medium tracking-[0.34em] text-[var(--mint-green)] uppercase mb-2.5">
              {label}
            </p>

            {/* Headline */}
            <h2 className="mt-4 font-bricolage text-[26px] sm:text-[32px] md:text-[36px] lg:text-[38px] font-bold leading-[1.2] tracking-[-0.8px] text-[#f4f7f5]">
              {title}
            </h2>

            {/* Description */}
            <p className="mt-4 font-jakarta text-[15px] sm:text-[16px] leading-[1.65] text-[#9fa9a5]">
              {description}
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}


